module.exports = "<div *ngIf=\"!!message\" class=\"alert-success\">  \r\n    <p>\r\n      {{message}}\r\n    </p>\r\n   \r\n</div>"